import request from '../../shared/request'

export function getUsers() {
  return request('/users')
}

export function getAllUsers() {
  return request('/users/all')
}

export function getUserRoles() {
  return request('/users/roles')
}

export function updateUser(action) {
  return request(`/users/${action.id}`, {
    method: 'PUT',
    body: action.payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteUser(action) {
  return request(`/users/${action.id}`, {
    method: 'DELETE',
    body: action.payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function createUser(action) {
  return request('/users', {
    method: 'POST',
    body: action.payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function setInitialPassword(payload) {
  return request(`/users/${payload.username}/reset-password/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/user.js